/**
 * Environmental terminology for the analytics summary bars — see
 * `./labourHours` for the shape and the reasoning.
 *
 * Units are part of the term here, unlike the other two sections: an emissions
 * figure means nothing without `(tCO₂e)`, so the unit rides in the title rather
 * than being appended at the call site. `₂` is the real subscript, written once
 * so no call site has to remember it.
 *
 * NOT HERE: waste destination names, emission factors, and the environmental
 * category library — entity vocabulary with importers depending on it.
 *
 * Keys are alphabetical because lint sorts them.
 */
export const textEnvironmental = {
    carbonEmissions: "Carbon Emissions",
    newItems: "New Items",
    numberOfMaterials: "Number of Materials",
    ofMeasuredWaste: "of Measured Waste",
    ofTotalReportedValue: "of Total Reported Value",
    ofTotalValue: "of Total Value",
    /** The line a card falls back to when it has neither a movement nor a share:
     * it names the window the figure covers instead of inventing a comparison.
     * A card with no earlier window to move against would otherwise sit bare, and
     * a whole tab of bare cards (Energy, whose every card is a movement card)
     * reads as broken rather than as new. */
    reportedThisPeriod: "Reported This Period",
    scope1: "Scope 1 (tCO₂e)",
    scope2: "Scope 2 (tCO₂e)",
    scope3: "Scope 3 (tCO₂e)",
    scopes123: "Scope 1, 2 & 3 (tCO₂e)",
    totalEmissions: "Total Emissions (tCO₂e)",
    totalMaterials: "Total Materials (t)",
    totalTransport: "Total Transport (t·km)",
    totalWaste: "Total Waste",
    totalWaterUsed: "Total Water Used",
    wasteDiversion: "Waste Diversion"
};
